import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Ref } from "@eastsideco/salvo-ts";
import { YouTubePlayer } from "youtube-player/dist/types";
import Plyr from 'plyr';

/**
 * ----------------------------------------------------------------------------
 * Component: Video Player
 * - Creates featured video element for used with YouTube, Vimeo & Shopify
 * hosted videos.
 * ------------------------------------------------------------------------------
 */
@Component
export class VideoPlayer extends ThemeComponent  {
    @Ref({required: false}) video!: HTMLVideoElement|HTMLIFrameElement|HTMLDivElement;
    @Ref({required: false}) trigger!: HTMLButtonElement;
    @Ref({required: false}) close!: HTMLButtonElement;
    @Ref({required: false}) popup!: HTMLDivElement;

    private player!: Plyr;

    init() {
        this.playButton();
        if (!this.video) { return; }
        this.player = new Plyr(this.video);
        this.setEventListeners();

        const externalTrigger = this.parentElement?.querySelector('[data-ref="external-video-trigger"]');
        externalTrigger?.addEventListener('click', () => {
            this.handlePopup();
        });

    }

    /**
     * Set event listeners.
     */
    private setEventListeners() {
        if (!this.trigger) { return; }

        this.$listen(this.trigger, 'click', () => {
            this.handlePopup();

            document.body.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') {
                    this.handleClose();
                }
            });
        });

        this.$listen(this.close, 'click', () => {
            this.handleClose();
        });
    }

    /**
     * Handle video popup open.
     */
    private handlePopup() {
        this.popup.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        this.player.togglePlay();
    }

    /**
     * Handle video popup close.
     */
    private handleClose() {
        this.popup.classList.remove('is-active');
        document.body.style.overflow = 'auto';
        this.player.pause();
    }

    /**
     * Set event listeners.
     */
    private playButton() {
        const videoElement = this.querySelector('video') as HTMLVideoElement;
        if (!this.trigger) { return; }

        this.$listen(this.trigger, 'click', () => {
            if (videoElement.paused) {
                void videoElement.play();
            } else {
                void videoElement.pause();
            }
            this.trigger.classList.toggle('show');
        });
    }
}
